import { GlobalAppState } from '@state/store';

export const getFlightsSort = (state: GlobalAppState) => state.flightsSort;
